import React, { useRef } from "react";
import iconConfig1 from "../Resources/img/icon-config-1.png";
import iconConfig2 from "../Resources/img/icon-config-2.png";

import iconLink from "../Resources/img/icon-arrow-right.png";

const HideInput = ({ config, handleSendValue }) => {
  const downloadInput = useRef(null);

  const handleFile = (files) => {
    let fileName = "Seleccione un archivo";
    let fileValue;
    if (files.length !== 0) {
      fileName = files[0].name;
      fileValue = files[0];
      handleSendValue(fileName, fileValue);
    }
    downloadInput.current.value = null;
  };

  return (
    <div className="cardConfig">
      <input
        type="file"
        name={config.title}
        accept={"." + config.type}
        className="hide-input"
        onChange={(e) => handleFile(e.target.files)}
        ref={downloadInput}
      />

      <div
        className="cardConfig__container"
        onClick={() => downloadInput.current.click()}
      >
        <div className="cardConfig__container__header">
          <img
            src={config.id == 0 ? iconConfig1 : iconConfig2}
            alt=""
            className="cardConfig__container__header__image"
          />
        </div>
        <div className="cardConfig__container__body">
          <p className="cardConfig__container__body__title">{config.title}</p>
          <span className="cardConfig__container__body__link">
            {config.link} <img src={iconLink} />
          </span>
        </div>
      </div>
    </div>
  );
};

export default HideInput;
